;
define("facets_faceted_navigation_item.tpl", function(){});

